/**
 * Pure H OS · Sprint 12 · Launch mocks — types + live views.
 * Payload now lives in MongoDB `pureh_*` collections.
 */
import { liveArray } from "../services/store";

export type LaunchPhase = "planning" | "pre-order" | "soft-launch" | "public" | "post-launch";
export type LaunchProject = {
  id: string;
  productName: string;
  sku: string;
  codename: string;
  phase: LaunchPhase;
  readinessPct: number;
  targetDate: string;
  daysToLaunch: number;
  budgetEGP: number;
  spentEGP: number;
  preOrderTargetUnits: number;
  preOrderCurrentUnits: number;
  channels: string[];
  leadOwner: string;
  aiConfidence: number;
  narrative: string;
};
export const LAUNCH_PROJECTS: LaunchProject[] = liveArray<LaunchProject>("launch_projects");

export type ChecklistItem = {
  id: string;
  launchId: string;
  category: "Formula" | "Regulatory" | "Packaging" | "Supply" | "Marketing" | "Retail" | "Digital" | "Fulfillment";
  title: string;
  owner: string;
  status: "done" | "in-progress" | "blocked" | "todo";
  dueRelative: string;
};
export const CHECKLIST: ChecklistItem[] = liveArray<ChecklistItem>("checklist");

export type PreOrder = {
  id: string;
  launchId: string;
  customer: string;
  city: string;
  units: number;
  amountEGP: number;
  status: "confirmed" | "pending" | "cancelled";
  channel: "Web" | "Retail" | "Concierge";
  placedRelative: string;
};
export const PRE_ORDERS: PreOrder[] = liveArray<PreOrder>("pre_orders");

export type PreLaunchCampaign = {
  id: string;
  launchId: string;
  name: string;
  kind: "teaser" | "waitlist" | "influencer" | "press" | "concept-video";
  reach: number;
  subscribed: number;
  budgetEGP: number;
  spentEGP: number;
  status: "live" | "scheduled" | "complete";
  runsRelative: string;
};
export const PRE_LAUNCH_CAMPAIGNS: PreLaunchCampaign[] = liveArray<PreLaunchCampaign>("pre_launch_campaigns");

export type Subscriber = {
  id: string;
  email: string;
  name: string;
  city: string;
  source: "IG" | "TikTok" | "Web" | "Referral" | "Retail";
  interestedIn: string[];
  joinedRelative: string;
  ltvExpectedEGP: number;
};
export const SUBSCRIBERS: Subscriber[] = liveArray<Subscriber>("subscribers");
